import { type QSetQuestion, TagCategory } from '@exam-management/graphql';

type BaseTag = NonNullable<QSetQuestion['question']>['tags'][number];

type Tag = Pick<BaseTag, 'name'> & {
  category: `${NonNullable<BaseTag['category']>}` | null;
};

export function getTagData(tags: Tag[]) {
  return tags.reduce(
    (acc, tag) => {
      if (tag.category === TagCategory.Difficulty) {
        acc.difficulty = tag.name;
      } else if (tag.category === TagCategory.Calculation) {
        acc.calculation = tag.name;
      } else if (tag.category === TagCategory.LearningObjectiveStatement) {
        acc.los = tag.name;
      }
      return acc;
    },
    {
      difficulty: '',
      calculation: '',
      los: '',
    },
  );
}
